import _ from "lodash";
/**
 * Transforms object keys from camelCase to snake_case
 * @param  {Object} obj object with camel case keys
 * @param  {boolean} changeNumbers make numbers snake_case if true
 * @return {Object} an object with snake case keys
 * @example
 * //returns {
 *     test_key: 0
 *     test_key1: 1
 * }
 * snakeCaseObjectKeysToCamelCase({
 *     testKey: 0,
 *     testKey1: 1,
 * })
 * //returns {
 *     test_key_1: 1
 * }
 * * snakeCaseObjectKeysToCamelCase({
 *     testKey1: 1,
 * }, changeNumbers = true)
 */
const camelCaseObjectKeysToSnakeCase = (obj, changeNumbers = false) => {
  return _.transform(obj, (acc, value, key) => {
    if (changeNumbers) acc[_.snakeCase(key)] = _.isObject(value) ? camelCaseObjectKeysToSnakeCase(value) : value;
    else
      acc[_.snakeCase(key).replace(/_(\d+)$/, "$1")] = _.isObject(value)
        ? camelCaseObjectKeysToSnakeCase(value)
        : value;
  });
};
export default camelCaseObjectKeysToSnakeCase;
